
// a46385

export const ColorPalette = {
    mainColor: "#eccccf",
    secondaryColor: "#fe47b3",
    green: "#80da65",
    blue: "#01a7ec",
    backgroundColor: "#fa9c76",
    success: "#77af63",
    warning: "#ef0949"

}